import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'
import { editorialVerticalTextRevealAnimation } from '@/components/sections/animations/editorial-vertical-text'
import Spacer from '@/components/sections/spacer'

import { cn } from '@/lib/utils'

export type EditorialVerticalTextProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    title_alignment?: 'left' | 'center'
    title: string
    text: string
  }>

const EditorialVerticalText = ({
  title_alignment = 'left',
  title,
  text,
  ...props
}: EditorialVerticalTextProps) => {
  return (
    <Motion animation={editorialVerticalTextRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Spacer variant="xxl" />
          <Container>
            <Grid className="gap-y-spacing-2xl">
              {title ? (
                <div
                  className={cn('col-span-2 md:col-span-6', {
                    'lg:col-span-12': title_alignment === 'left',
                    'lg:col-span-6 lg:col-start-4': title_alignment === 'center'
                  })}
                >
                  <Typography variant="h3" component="h2" data-motion-title>
                    {title}
                  </Typography>
                </div>
              ) : null}

              {text ? (
                <div
                  className={cn(
                    'col-span-2 md:col-span-6',
                    'lg:col-span-6 lg:col-start-4'
                  )}
                >
                  <Typography
                    variant="regular"
                    paragraph
                    data-motion-text
                    className="text-regular md:text-large text-text-primary-light dark:text-text-primary-dark"
                  >
                    {text}
                  </Typography>
                </div>
              ) : null}
            </Grid>
          </Container>
          <Spacer variant="xxl" />
        </Section>
      )}
    </Motion>
  )
}

export default EditorialVerticalText
